var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListUnordered(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.14314 4.28575C7.14314 3.49677 7.78273 2.85718 8.57171 2.85718H15.7146C16.5035 2.85718 17.1431 3.49677 17.1431 4.28575C17.1431 5.07473 16.5035 5.71432 15.7146 5.71432H8.57171C7.78273 5.71432 7.14314 5.07473 7.14314 4.28575ZM8.57171 8.57146C7.78273 8.57146 7.14314 9.21106 7.14314 10C7.14314 10.789 7.78273 11.4286 8.57171 11.4286H15.7146C16.5035 11.4286 17.1431 10.789 17.1431 10C17.1431 9.21106 16.5035 8.57146 15.7146 8.57146H8.57171ZM8.57171 14.2857C7.78273 14.2857 7.14314 14.9253 7.14314 15.7143C7.14314 16.5033 7.78273 17.1429 8.57171 17.1429H15.7146C16.5035 17.1429 17.1431 16.5033 17.1431 15.7143C17.1431 14.9253 16.5035 14.2857 15.7146 14.2857H8.57171ZM4.28599 11.4286C5.07497 11.4286 5.71456 10.789 5.71456 10C5.71456 9.21106 5.07497 8.57146 4.28599 8.57146C3.49702 8.57146 2.85742 9.21106 2.85742 10C2.85742 10.789 3.49702 11.4286 4.28599 11.4286ZM5.71456 15.7143C5.71456 16.5033 5.07497 17.1429 4.28599 17.1429C3.49702 17.1429 2.85742 16.5033 2.85742 15.7143C2.85742 14.9253 3.49702 14.2857 4.28599 14.2857C5.07497 14.2857 5.71456 14.9253 5.71456 15.7143ZM4.28599 5.71432C5.07497 5.71432 5.71456 5.07473 5.71456 4.28575C5.71456 3.49677 5.07497 2.85718 4.28599 2.85718C3.49702 2.85718 2.85742 3.49677 2.85742 4.28575C2.85742 5.07473 3.49702 5.71432 4.28599 5.71432Z",
    fill: "#2D72FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListUnordered);
export default __webpack_public_path__ + "static/media/list_unordered.b45d75337b53a4ec8694cf9a2e195cbd.svg";
export { ForwardRef as ReactComponent };